import intl from 'react-intl-universal';
import AppDispatcher from '../dispatcher/AppDispatcher';
import PackConstants from '../constants/PackConstants';
import PackActions from '../actions/PackActions';
import Popup from 'react-popup';
import { EventEmitter } from 'events';

const CHANGE_EVENT = 'change';

let _packs = [];
let _boxes = [];
let _pack = {};

function setPacks(packs) {
  _packs = packs;
}

function setPack(pack) {
  _pack = pack;
}

function setBoxes(boxes) {
  _boxes = boxes;
}

class PackStoreClass extends EventEmitter {

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback)
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback)
  }

  getPacks() {
    return _packs;
  }

  getPack() {
    return _pack;
  }

  getBoxes() {
    return _boxes;
  }

}

const PackStore = new PackStoreClass();

// Here we register a callback for the dispatcher
// and look for our various action types so we can
// respond appropriately
PackStore.dispatchToken = AppDispatcher.register(action => {

  switch(action.actionType) {
    case PackConstants.RECIEVE_PACKS:
      setPacks(action.packs)
      PackStore.emitChange()
      break

    case PackConstants.RECIEVE_PACKS_ERROR:
      Popup.alert(action.message);
      PackStore.emitChange()
      break

    case PackConstants.RECIEVE_PACK:
      setPack(action.pack)
      PackStore.emitChange()
      break

    case PackConstants.RECIEVE_PACK_ERROR:
      Popup.alert(action.message)
      PackStore.emitChange()
      break

    case PackConstants.RECIEVE_MULTIPACK:
      if(action.boxes.filter(b => { return !b[4] }).length > 0){
        setBoxes(action.boxes)
        PackStore.emitChange()
      } else {
        Popup.create({
          content: intl.get('W tej paczce nie ma już zamówień'),
          buttons: {
            right: [{text: intl.get('Wybierz inną paczkę'),
                    className: 'ok',
                    key: 'enter',
                    action: function () {
                      Popup.close()
                      PackActions.selectPack(false)
                    }}]
          }
        })
      }
      break

    case PackConstants.RECIEVE_MULTIPACK_ERROR:
      Popup.alert(action.message)
      PackStore.emitChange()
      break

    case PackConstants.ADD_PACKAGE:
      Popup.alert(intl.get('Paczka została dodana'))
      PackStore.emitChange()
      break

    case PackConstants.ADD_PACKAGE_ERROR:
      Popup.alert(intl.get('Wystąpił błąd podczas dodawania paczki!')+'\n\n' + action.message)
      PackStore.emitChange()
      break

    case PackConstants.ADD_DELIVERY:
      Popup.alert(intl.get('Przesyłka została dodana'))
      PackStore.emitChange()
      break

    case PackConstants.ADD_DELIVERY_ERROR:
      Popup.alert(intl.get('Wystąpił błąd podczas dodawania przesyłki!')+'\n\n' + action.message)
      PackStore.emitChange()
      break

    case PackConstants.PRINT_LABEL:
      Popup.alert(intl.get('Etykieta została wysłana do druku'))
      PackStore.emitChange()
      break

    case PackConstants.PRINT_LABEL_ERROR:
      Popup.alert(intl.get('Wystąpił błąd podczas drukowania etykiety!')+'\n\n' + action.message)
      PackStore.emitChange()
      break

    default:
  }

});

export default PackStore;



// WEBPACK FOOTER //
// ./src/stores/PackStore.js